import { useCallback } from "react";
import { Accept, useDropzone } from "react-dropzone";
import classnames from "classnames";
import { FormGroup, Label } from "reactstrap";
import { formatSizeUnits } from "@/utils/byteFormatter";

type Props = {
  label: string;
  name: string;
  error?: string;
  required?: boolean;
  inputSize?: "sm";
  onFileUpload: (file: File) => void;
  acceptedFormats?: Accept;
  disabled?: boolean;
  selectedFile: File | null;
};

const FileUpload = ({
  label,
  name,
  error,
  required,
  inputSize,
  onFileUpload,
  acceptedFormats,
  disabled,
  selectedFile,
}: Props) => {
  const onDrop = useCallback(
    (acceptedFiles: File[]) => {
      if (acceptedFiles.length > 0) {
        onFileUpload(acceptedFiles[0]);
      }
    },
    [onFileUpload]
  );

  const { getRootProps, getInputProps } = useDropzone({
    onDrop,
    accept: acceptedFormats,
    multiple: false,
    disabled,
  });

  return (
    <FormGroup className="mb-1">
      <Label for={name}>
        {label}
        {required && <span className="text-danger"> *</span>}
      </Label>
      <div
        {...getRootProps({
          className: classnames("dropzone", "form-control", {
            "form-control-sm": inputSize === "sm",
            "is-invalid": error,
            disabled,
          }),
        })}
      >
        <input {...getInputProps()} />
        {selectedFile ? (
          <p className={classnames("p-1", "m-0", "bg-light")}>{`${
            selectedFile.name
          } - ${formatSizeUnits(selectedFile.size)}`}</p>
        ) : (
          <p className="text-muted">Click to upload the file...</p>
        )}
      </div>
      {error && <div className="invalid-feedback">{error}</div>}
    </FormGroup>
  );
};

export default FileUpload;
